

import { Button, Col, Input, Row, Select } from 'antd';
import './IntegrationSimulationConsoleComponent.scss';
import { useEffect, useState } from 'react';
import { ClearOutlined, SaveOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const IntegrationSimulationConsoleComponent = (): JSX.Element => {

  const { t } = useTranslation();
  const [visible, setVisible] = useState<boolean>(true);

  const [url, setUrl] = useState<string>('https://connect.dev.one-suite.tech/api/v1/');
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [market, setMarket] = useState<string>('');


  const setParameters = () => {
    // Guarda en sessionStorage los parámetros de conexión
    sessionStorage.setItem("integration-simulation-url", url);
    sessionStorage.setItem("integration-simulation-username", username);  
    sessionStorage.setItem("integration-simulation-password", password);
    sessionStorage.setItem("integration-simulation-market", market);
  }

  const clearDataUrl = () => {
    setUrl('');
    sessionStorage.removeItem("integration-simulation-url");
  }

  const clearDataUserName = () => {
    setUsername('');
    sessionStorage.removeItem("integration-simulation-username");
  }

  const clearPassword = () => {
    setPassword('');
    sessionStorage.removeItem("integration-simulation-password");
  }

  const clearMarket = () => {
    setMarket('');
    sessionStorage.removeItem("integration-simulation-market");
  }

  const clearAllData = () => {
    clearDataUrl();
    clearDataUserName();
    clearPassword();
    clearMarket();
  }

  const hideDiv = () => {
    setVisible(false);
  };

  const loadFromSessionStorage = () => {
    const url = sessionStorage.getItem("integration-simulation-url");
    const username = sessionStorage.getItem("integration-simulation-username");
    const password = sessionStorage.getItem("integration-simulation-password");
    const market = sessionStorage.getItem("integration-simulation-market");
    if (url) {
      setUrl(url);
    }
    if (username) {
      setUsername(username);
    }
    if (password) {
      setPassword(password);
    }
    if (market) {
      setMarket(market);
    }
  }

  useEffect(() => {
    loadFromSessionStorage();
  }, []);

  return (
    <div className={`integration-simulation-console ${visible ? '' : 'hidden'}`}>
      <h2 className="app-tite">{t('integration-simulation.title')}</h2>  
      <span className="hide-integration-console" onClick={hideDiv} />    
      <Row gutter={16} className="integration-simulation-console-title">
        <Col xs={24} md={5}>
          <Select defaultValue={url} className="app-select" onChange={(value) => setUrl(value)} style={{ width: '100%' }}>
            <Select.Option value="https://connect.one-suite.tech/api/v1/">{t('integration-simulation.production-env')}</Select.Option>
            <Select.Option value="https://connect.dev.one-suite.tech/api/v1/">{t('integration-simulation.development-env')}</Select.Option>
          </Select>
          <small>{t('integration-simulation.default-development-env')}</small>
        </Col>
        <Col xs={24} md={5}>
          <Input allowClear onClear={clearMarket} value={market} onChange={(e) => setMarket(e.target.value)} className="app-input" placeholder={t('integration-simulation.market-placeholder')!}/>
          <small>{t('integration-simulation.default-market')}</small>
        </Col>
        <Col xs={24} md={5}>
          <Input allowClear onClear={clearDataUserName} value={username} onChange={(e) => setUsername(e.target.value)} className="app-input" placeholder={t('integration-simulation.username-placeholder')!}/>
          <small>{t('integration-simulation.default-server-config')}</small>
        </Col>
        <Col xs={24} md={5}>
          <Input.Password allowClear onClear={clearPassword} value={password} onChange={(e) => setPassword(e.target.value)} className="app-input" placeholder={t('integration-simulation.password-placeholder')!}/>
          <small>{t('integration-simulation.default-server-config')}</small>
        </Col>
        <Col xs={24} md={4} className="actions">
          <Button className="app-button btn-asign" type="primary" onClick={setParameters}><SaveOutlined /> {t('integration-simulation.save')}</Button>
          <Button className="app-button btn-asign" type="primary" onClick={clearAllData}><ClearOutlined /> {t('integration-simulation.clear')}</Button>
        </Col>
        <Col xs={24} md={4} className="actions">
          <br/>
        </Col>
      </Row>
      <small>
        <strong>{t('error.warning')}:</strong> {t('integration-simulation.warning-default')}
      </small>
      <small>
        <strong>{t('error.warning')}:</strong> {t('integration-simulation.warning-availability')}
      </small>
    </div>
  );
}

export default IntegrationSimulationConsoleComponent;

